export function albumCorrectionMessage(state, en = false) {
  if (state?.kind !== 'albumCorrection') return '';
  const label = [state.artistName, state.albumTitle].filter(Boolean).join(' - ');
  return [
    en ? '[Album Information Correction]' : '[앨범 정보 수정 제안]',
    label ? `${en ? 'Album' : '앨범'}: ${label}` : '',
    state.albumPath ? `URL: https://postpop.kr/reviews/${state.albumPath}` : '',
    '',
    en ? 'What needs correcting:' : '수정이 필요한 항목:',
    '',
    en ? 'Correct information:' : '수정 내용:',
    '',
    en ? 'Verifiable source:' : '확인 가능한 출처:',
  ]
    .filter((line, i, lines) => line || (i > 0 && lines[i - 1]))
    .join('\n');
}
